module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[38]37.06fb470.woff2";